import { getColorStatusByColor } from "../../helpers/get-color-by-value";
import { getTextByWaringValue } from "../../helpers/get-text-by-warning-value";
import WarningMapCard from "../warning-map-card/WarningMapCard";

import "./style.scss";

type WarningMapListProps = {
	selectedDate: Date;
	maxToday: number;
	maxTomorrow: number;
	handleSelectDate: (date: Date) => void;
};

export const WarningMapList = ({
	selectedDate,
	maxToday,
	maxTomorrow,
	handleSelectDate,
}: WarningMapListProps) => {
	const currentDate = new Date();

	return (
		<div className="warning-map-list">
			<WarningMapCard
				date={currentDate}
				title={getTextByWaringValue(maxToday)}
				color={getColorStatusByColor(maxToday)}
				setDate={(date: Date) => handleSelectDate(date)}
				selectedDate={selectedDate}
			/>
			<WarningMapCard
				setDate={(date: Date) => handleSelectDate(date)}
				date={new Date(new Date().setDate(currentDate.getDate() + 1))}
				title={getTextByWaringValue(maxTomorrow)}
				color={getColorStatusByColor(maxTomorrow)}
				selectedDate={selectedDate}
			/>
		</div>
	);
};

export default WarningMapList;
